import React from "react";
import { HistoryDetailsTableWidget } from "../widgets/advance-tables/HistoryDetailsTableWidget";

export function HistoryDetails() {
  return <HistoryDetailsTableWidget />;
}
